import React from "react"

function Utah() {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="56" height="80" viewBox="0 0 56 80">
            <path d="M18.88 16.4l0.16-0.24-0.16-0.24-0.080 0.080zM22.24 17.92v-1.2l-0.64-1.2v1.28zM20.88 14.8l-0.24-0.64-0.4 0.16zM9.040 4.32l-3.36-0.16-1.68 59.6 23.84 0.4 23.84-0.4-1.2-47.6-18.080 0.24v-11.84zM16.080 8.72l0.8-0.56 0.72 0.56-0.32 1.68 0.8 0.8 1.12 0.16 0.8 2.64 0.64-0.4-0.4-2.64 1.040 0.16v0.64h2l-0.4 0.64-1.28-0.080-0.72 0.8 0.56 0.080 1.36 2.4 1.6 1.2-1.76 1.12-0.56 1.2-1.44 1.040-0.56-0.24-0.8-2.8-0.48 1.28-0.72-1.28-1.2-0.8-0.080-2.16-0.56-1.040-0.64-0.72-0.56 0.72-0.4-0.16 0.64-0.56-0.64-2.4 0.4-0.4-0.4-0.48z"></path>
        </svg>
    )
}

export default Utah